import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import * as serviceWorker from './serviceWorker.js';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import {I18nextProvider} from "react-i18next";
import i18next from "i18next";
import './index.css';
import {GlobalProvider} from "./mobx/GlobalStorage.js";
import obs_en from "./translations/en.json";
import obs_fi from "./translations/fi.json";
import React from 'react';
import App from './App';

i18next.init({
	interpolation: { escapeValue: false },  // React already does escaping
	lng: 'fi',                              // language to use
	resources: {
            en: {
                obs: obs_en
            },
            fi: {
                obs: obs_fi
            },
        },
});

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
	<LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale='fi'>
		<I18nextProvider i18n={i18next}>
			<BrowserRouter>
				<GlobalProvider>
					<App />
				</GlobalProvider>
			</BrowserRouter>
		</I18nextProvider>
	</LocalizationProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
